import { Spin } from "antd";
import { ReactNode } from "react";

const WithLoader = ({
  children,
  isLoading,
  height
}: {
  children: ReactNode;
  isLoading: boolean;
  height?:number;
}) => {
  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute left-0 right-0 top-0 bottom-0 bg-white/80 z-50 w-ful h-full flex items-center justify-center flex-col gap-2">
          <Spin className="" size="large" />
          <span className="text-display-body font-medium text-sm ml-2">Loading...</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default WithLoader;
